exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\r\n* Auto-generated\r\n* Do not edit!!!\r\n*/", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/vjug.INFODESIGN/OtvoreniGrad2/app/src/app/auth-callback/auth-callback.component.css
// module id = ../../../../../src/app/auth-callback/auth-callback.component.css
// module chunks = main